export default "__VITE_ASSET__6mT5dbEA__"